import { actionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';
import { apiCallStatus } from 'helpers/constants';
import { TimeSeriesApi } from 'api';


const getTrendKPIListAction = getApiActionCreator(actionTypes.GET_TREND_KPIS);
export const getTrendKPIListForAsset = (asset) => {
    return (dispatch) => {
        dispatch(getTrendKPIListAction(apiCallStatus.LOADING));
        TimeSeriesApi.getMeasurementTypes(asset?.id)
            .then((data) => {
                dispatch(getTrendKPIListAction(apiCallStatus.SUCCESS, data));
            })
            .catch((err) => {
                dispatch(getTrendKPIListAction(apiCallStatus.ERROR, null, err));
            });
    };
};
